const FINANCIAL_OPERATIONS_TYPES = [{
  label: 'Payables',
  value: 1,
  key: 1,
  icon: 'BugFilled', // represents an outgoing obligation (problematic or attention-worthy)
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Receivables',
  value: 2,
  key: 2,
  icon: 'TaskFilled', // reflects incoming items/tasks
  color: '#2e7d32',
  background: 'rgba(200,230,201,0.16)'
}, {
  label: 'Payroll',
  value: 3,
  key: 3,
  icon: 'EpicFilled', // major recurring process
  color: '#0288d1',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Reimbursements',
  value: 4,
  key: 4,
  icon: 'SubtaskFilled', // small, reactive processes
  color: '#8e24aa',
  background: 'rgba(225,190,231,0.16)'
}, {
  label: 'Finance Helpdesk',
  value: 5,
  key: 5,
  icon: 'SupportFilled',
  color: '#00695c',
  background: 'rgba(178,223,219,0.16)'
}, {
  label: 'Audit Support',
  value: 6,
  key: 6,
  icon: 'ChangerequestFilled', // request/investigation-based
  color: '#f57c00',
  background: 'rgba(255,224,178,0.16)'
}];

const BUDGET_CREATION_TYPES = [{
  label: 'Annual Budget',
  value: 1,
  key: 1,
  icon: 'FeatureRequestFilled', // large-scale, annual planning
  color: '#1565c0',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Team Budget',
  value: 2,
  key: 2,
  icon: 'StoryFilled', // team-level context
  color: '#5e35b1',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Rolling Forecast',
  value: 3,
  key: 3,
  icon: 'TaskFilled',
  color: '#2e7d32',
  background: 'rgba(165,214,167,0.16)'
}, {
  label: 'Budget Approval',
  value: 4,
  key: 4,
  icon: 'ImprovementsFilled', // action needed
  color: '#ef6c00',
  background: 'rgba(255,224,178,0.16)'
}, {
  label: 'Reserve Plan',
  value: 5,
  key: 5,
  icon: 'EpicFilled',
  color: '#00695c',
  background: 'rgba(178,223,219,0.16)'
}];

const PROJECT_FINANCE_MANAGEMENT_TYPES = [{
  label: 'Cost Estimation',
  value: 1,
  key: 1,
  icon: 'StoryFilled',
  color: '#1976d2',
  background: 'rgba(144,202,249,0.16)'
}, {
  label: 'Cost Allocation',
  value: 2,
  key: 2,
  icon: 'TaskFilled',
  color: '#c62828',
  background: 'rgba(255,171,145,0.16)'
}, {
  label: 'Expense Track',
  value: 3,
  key: 3,
  icon: 'BugFilled', // used to track or flag anomalies
  color: '#fbc02d',
  background: 'rgba(255,249,196,0.16)'
}, {
  label: 'Milestone Pay',
  value: 4,
  key: 4,
  icon: 'SubtaskFilled',
  color: '#6a1b9a',
  background: 'rgba(209,196,233,0.16)'
}, {
  label: 'Project Report',
  value: 5,
  key: 5,
  icon: 'SupportFilled',
  color: '#455a64',
  background: 'rgba(176,190,197,0.16)'
}];

export {
  FINANCIAL_OPERATIONS_TYPES,
  BUDGET_CREATION_TYPES,
  PROJECT_FINANCE_MANAGEMENT_TYPES
};
